module.exports = __webpack_public_path__ + "static/img/bg6.2f8cb1b0.png";